import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import Grid from "@mui/material/Grid";
import ProviderSummary from "./ProviderSummary";
import About from "./About";
import WhyChoose from "./WhyChoose";
import CustomerJourney from "./CustomerJourney";
import OurTechnology from "./OurTechnology";
import CaseStudies from "./CaseStudies";  // new import
import Reviews from "./Reviews";  // new import
import Navigation from "./Navigation"; // new import
import ProviderReviews from "./ProviderReviews";



const Profile = (props) => {
    const profileDetails = props.profileDetails || {};
    // Default to null for placeData, so we can distinguish between 'not loaded' and 'no data'
    // Google Place / Reviews temporarily disabled. Leaving state & effect commented for future reinstatement.
    // const [placeData, setPlaceData] = useState(null);
    // useEffect(() => {
    //     if (profileDetails.placeId) {
    //         fetch('https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/google-reviews', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify({ placeId: profileDetails.placeId }),
    //         })
    //             .then(res => res.json())
    //             .then(data => {
    //                 if (data && data.result) {
    //                     setPlaceData(data.result);
    //                 } else {
    //                     setPlaceData({});
    //                 }
    //             })
    //             .catch(() => setPlaceData({}));
    //     } else {
    //         setPlaceData({});
    //     }
    // }, [profileDetails.placeId]);
    // console.log('Result:', props);
    

    // Detect mobile for conditional padding
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    // Use a single inner container style with only horizontal padding and white background
    const innerContainerStyle = { maxWidth: "1200px", margin: "0 auto", padding: "0", backgroundColor: "#fff", borderRadius: "11px" };

    return (
        <>
            <Helmet>
                <title>{props.name ? `${props.name} - Solar Installers` : 'Solar Installers'}</title>
                <meta name="description" content={props?.metaDescription || `${props.name} - Solar Installers`} />
            </Helmet>
            <Grid
            container
            spacing={1}
            style={{
                backgroundColor: "#f3f5f7",
                // Increased vertical padding to create space above and below the white card content
                paddingTop: isMobile ? 10 : 50,
                paddingBottom: isMobile ? 40 : 70,
                // Add outer margin so content isn't flush with viewport edges beneath sticky header
                marginTop: isMobile ? 0 : 20,
                marginBottom: isMobile ? 20 : 40
            }}
        >

            {/* Provider Summary */}
            <Grid size={12}>
                <Grid container style={innerContainerStyle}>
                    <ProviderSummary 
                        profileDetails={{ ...profileDetails, slug: props.slug }} 
                        technology={props.technology}
                        /* reviewsUrl, reviewsRating, reviewsTotal, openingHours intentionally omitted while Google data disabled */
                        name={props.name}
                        url={props.url}
                        profileVerified={props.profileVerified}
                    />
                </Grid>
            </Grid>
            {/* Navigation */}
            <Grid size={12}>
                <Grid container style={innerContainerStyle}>
                    <Navigation 
                        hasRatings={false} /* ratings hidden while reviews disabled */
                        hasCaseStudies={Array.isArray(props.projects) && props.projects.length > 0}
                        hasCustomerJourney={Array.isArray(props.profileDetailsExtended?.customerJourney) && props.profileDetailsExtended.customerJourney.length > 0}
                        hasReviews={profileDetails?.reviewsEnabled === true}
                        hasBullets={Object.values(profileDetails.bullets || {}).some(Boolean)}
                    />
                </Grid>
            </Grid>

            {/* About & Why Choose Us */}
            <Grid size={12} id="about">
                <Grid container style={innerContainerStyle}>
                    <About name={props.name} profileDetailsExtended={props.profileDetailsExtended} teamPicture={profileDetails.teamPicture} />
                </Grid>
            </Grid>

            {/* Provider Reviews - data-driven */}
            {profileDetails?.reviewsEnabled === true && (
                <Grid size={12} id="reviews">
                    <Grid container style={innerContainerStyle}>
                        <ProviderReviews
                            companyName={props.name}
                            rating={profileDetails.reviewsRating}
                            elfsightCode={profileDetails.reviewsElfsightCode}
                            buttonText={profileDetails.reviewsButtonText}
                            buttonLink={profileDetails.reviewsButtonLink}
                        />
                    </Grid>
                </Grid>
            )}

            {/* Our Technology */}
            <Grid size={12} id="technology">
                <Grid container style={innerContainerStyle}>
                    <OurTechnology name={props.name} tech={props.technology} panelWarranty={profileDetails.panelWarranty} />
                </Grid>
            </Grid>

            {/* Customer Journey */}
            <Grid size={12} id="customer-journey">
                <Grid container style={innerContainerStyle}>
                    <CustomerJourney 
                        name={props.name} 
                        profileDetailsExtended={props.profileDetailsExtended} 
                        primaryColor={profileDetails.primaryColor}
                    />
                </Grid>
            </Grid>

            {/* Case Studies */}
            {Array.isArray(props.projects) && props.projects.length > 0 && (
                <Grid size={12} id="case-studies">
                    <Grid container style={innerContainerStyle}>
                        <CaseStudies 
                            projects={props.projects} 
                            primaryColor={profileDetails.primaryColor}
                        />
                    </Grid>
                </Grid>
            )}

            {/* Why Choose folded into About */}

        </Grid>
        </>
    );
};

export default Profile;